<template>
	<div class="container m_container" :class="openType != 'mob' ? 'flex_center flex_items vh100' : ''"
		:style="openType != 'mob' ? 'overflow-y: auto;height:100vh' : ''">
		<div style="box-sizing: border-box;padding-bottom: 20px;"
			:style="openType == 'mob' ? 'min-height: 100vh;' : 'overflow-y: auto;'" class="plr20 pt20 page_bg"
			:class="openType != 'mob' ? 'container_w_h' : ''">
			<div class="bgfff b_r_10 plr20 pt20 pb20">
				<div class="page_title mb20">签到表</div>
				<div class="mb20" @click="popShow" v-if="openType == 'mob'">
					{{chooseTime}}
					<van-icon name="arrow-down" v-if="!signId" />
				</div>
				<div class="mb20" v-else>
					<el-select v-model="value" :disabled="signId ? true : false" placeholder="请选择" @change="dateChange">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="tab flex_between flex_items txt_center mb20">
					<div style="width: 50%;" class="pos pointer" :class="timerCheck == 0 ? 'check' : 'ca6'"
						@click="handleTimerCheck(0)">上午</div>
					<div style="width: 50%;" class="pos pointer" :class="timerCheck == 1 ? 'check' : 'ca6'"
						@click="handleTimerCheck(1)">下午</div>
				</div>
				<div class="calendar pos">
					<Calendar v-show="timerCheck == 0" ref="alltime" row-height="45" :default-date="defaultDate"
						:poppable="false" :show-subtitle="false" :show-confirm="false" :show-title="false"
						:style="{ height: '300px' }" type="multiple" color="#00D8CC" :max-date="maxD"
						:min-date="minDate" @select="onConfirm" @unselect="unselect">
					</Calendar>
					<Calendar v-show="timerCheck == 1" ref="alltime1" row-height="45" :default-date="defaultDate1"
						:poppable="false" :show-subtitle="false" :show-confirm="false" :show-title="false"
						:style="{ height: '300px' }" type="multiple" color="#3399FF" :max-date="maxD"
						:min-date="minDate" @select="onConfirm1" @unselect="unselect1">
					</Calendar>
				</div>
				<!-- <div class="pt20 bor_t flex flex_between mb20">
					<template v-if="openType == 'mob'">
						<div>签到开始时间</div>
						<div class="flex flex_items" @click="show1 = true" :class="currentTime ? '' : 'ca6'">
							{{currentTime ? currentTime :'请选择开始时间'}}
							<van-icon name="arrow" class="ml10" />
						</div>
					</template>
					<template v-else>
						<el-time-picker format='HH:mm' value-format="HH:mm" style="width: 310px;" v-model="currentTime"
							placeholder="请选择签到开始时间">
						</el-time-picker>
					</template>
				</div> -->
				<!-- <div class="pt20 bor_t flex flex_between">
					<template v-if="openType == 'mob'">
						<div>签到结束时间</div>
						<div class="flex flex_items" @click="show2 = true" :class="currentTimeEnd ? '' : 'ca6'">
							{{currentTimeEnd ? currentTimeEnd :'请选择结束时间'}}
							<van-icon name="arrow" class="ml10" />
						</div>
					</template>
					<template v-else>
						<el-time-picker format='HH:mm' value-format="HH:mm" style="width: 310px;"
							v-model="currentTimeEnd" placeholder="请选择签到结束时间">
						</el-time-picker>
					</template>
				</div> -->
			</div>
			<div class="bottom_btn_1">
				<div class="btn_contenbt" @click="submit">确定{{signId ? '修改' : ''}}</div>
				<div class="btn_contenbt" @click="del" style="color: #FE6F90;background: #f9f9f9;">删除</div>
			</div>
		</div>
		<!-- 年月选择器 -->
		<Popup v-model="show" position="bottom">
			<DatetimePicker v-model="currentDate" @cancel="show = false" @confirm="timeConfirm" type="year-month"
				title="选择年月" :min-date="timeMinDate" :max-date="timeMaxDate">
			</DatetimePicker>
		</Popup>
		<!-- 时间选择器 -->
		<Popup v-model="show1" position="bottom">
			<DatetimePicker v-model="currentTime" @cancel="show1 = false" @confirm="show1 = false" type="time"
				title="选择开始时间">
			</DatetimePicker>
		</Popup>
		<Popup v-model="show2" position="bottom">
			<DatetimePicker v-model="currentTimeEnd" @cancel="show2 = false" @confirm="show2 = false" type="time"
				title="选择结束时间">
			</DatetimePicker>
		</Popup>

	</div>
</template>
<script>
	import {
		Calendar,
		DatetimePicker,
		Popup,
		Dialog
	} from "vant";
	import {
		openType
	} from '@/utils/tool.js'
	export default {
		data() {
			return {
				user: {},
				chooseTime: '',
				maxD: "",
				minDate: new Date(),
				selectTime: [], //上午选中
				selectTime1: [], //下午选中
				show: false,
				show1: false,
				show2: false,
				timeMinDate: '',
				timeMaxDate: '',
				currentDate: '',
				timer: '',
				currentTime: '', //开始
				currentTimeEnd: '', //结束
				defaultDate: null,
				defaultDate1: null,
				openType: openType(),
				options: [],
				value: '',
				id: '', //项目id
				flag: true,
				signId: '', //签到表id，
				timerCheck: 0,
			};
		},
		components: {
			Calendar,
			DatetimePicker,
			Popup
		},
		methods: {
			// 提交
			submit() {
				// console.log(this.selectTime,this.currentTime,this.currentTimeEnd)
				if (this.selectTime.length == 0 && this.selectTime1.length == 0) {
					this.Toast('请选择发布日期')
					return
				}
				// if (!this.currentTime) {
				// 	this.Toast('请选择签到开始时间')
				// 	return
				// }
				// if (!this.currentTimeEnd) {
				// 	this.Toast('请选择签到结束时间')
				// 	return
				// }
				let month = '';
				let days = [];
				let days1 = [];
				this.selectTime.map((r, i) => {
					if (i == 0) {
						let d = ''
						if ((r.getMonth() + 1).toString().length == 1) {
							d = '0' + (r.getMonth() + 1)
						} else {
							d = (r.getMonth() + 1).toString()
						}
						month = r.getFullYear() + d
					}
					days.push(r.getDate())
				})
				this.selectTime1.map((r, i) => {
					days1.push(r.getDate())
				})
				let arr = [...new Set(days.concat(days1))];
				if (!this.flag) {
					return
				}
				this.flag = false;
				let p = {
					month: month,
					days: JSON.stringify(arr),
					forenoon: JSON.stringify(days),
					afternoon: JSON.stringify(days1),
					time_start: this.currentTime ? this.currentTime + ':00' : '',
					time_end: this.currentTimeEnd ? this.currentTimeEnd + ':00' : '',
				}
				if (!this.signId) {
					//新建
					this.api.planNew(p, this.id).then((res) => {
						this.Toast('创建成功')
						setTimeout(() => {
							window.history.go(-1)
						}, 1500)
						this.flag = true
					}).catch(() => {
						this.flag = true
					});
				} else {
					//修改
					this.api.planUpdate(p, this.signId).then((res) => {
						this.Toast('修改成功')
						setTimeout(() => {
							window.history.go(-1)
						}, 1500)
						this.flag = true
					}).catch(() => {
						this.flag = true
					});
				}
			},
			handleTimerCheck(t) {
				this.timerCheck = t;
			},
			//时间确定
			timerConfirm(e) {
				this.show1 = false
			},
			// 日期确定
			timeConfirm(e) {
				this.chooseTime = e.getFullYear() + '年' + (e.getMonth() + 1) + '月';
				this.show = false;
				if (e.getMonth() == new Date().getMonth() && e.getFullYear() == new Date().getFullYear()) {
					//选择当月
					this.minDate = new Date();
					this.maxD = this.getMonthLastDateFn(e.getFullYear(), e.getMonth() + 1);
				} else {
					this.minDate = new Date(e.getFullYear(), e.getMonth(), 1);
					this.maxD = new Date(e.getFullYear(), e.getMonth() + 1, 0);
				}
				this.$refs.alltime.reset()
				this.$refs.alltime1.reset()
				this.$forceUpdate()
			},
			//上午日历点击选中
			onConfirm(dates) {
				this.selectTime = dates
			},
			//下午日历点击选中
			onConfirm1(dates) {
				this.selectTime1 = dates
			},
			//上午日历点击取消
			unselect(dates) {
				for (let i = 0; i < this.selectTime.length; i++) {
					if (this.selectTime[i].valueOf() == dates.valueOf()) {
						this.selectTime.splice(i, 1);
						return
					}
				}
			},
			//下午日历点击取消
			unselect1(dates) {
				for (let i = 0; i < this.selectTime1.length; i++) {
					if (this.selectTime1[i].valueOf() == dates.valueOf()) {
						this.selectTime1.splice(i, 1);
						return
					}
				}
			},
			getMonthLastDateFn(y, m) {
				let dateObj = new Date(y, m, 0);
				let theMonthDay = dateObj.getDate();
				let str = new Date(y + '/' + m + '/' + theMonthDay);
				return str;
			},
			getThisMoneth(y, m) {
				let str = new Date(y + '/' + (m + 1) + '/' + 1);
				return str;
			},
			popShow() {
				if (this.signId) {
					return
				}
				this.show = true;
				this.selectTime = [];
			},
			//pc端选择日期
			dateChange() {
				let y = Number(this.value.split('年')[0]);
				let m = Number(this.value.split('年')[1].substr(0, this.value.split('年')[1].length - 1))
				if (this.value == this.options[0].value) {
					//选择当月
					this.minDate = new Date();
					this.maxD = this.getMonthLastDateFn(y, m);
				} else {
					this.minDate = new Date(y, m - 1, 1);
					this.maxD = new Date(y, m, 0);
				}
				this.$refs.alltime.reset();
				this.$refs.alltime1.reset();
			},
			pcDateSelectData() {
				let d = new Date();
				this.options = [{
					value: d.getFullYear() + '年' + (d.getMonth() + 1) + '月',
					label: d.getFullYear() + '年' + (d.getMonth() + 1) + '月',
				}];
				let p = [];
				let y = d.getFullYear();
				let m = d.getMonth() + 1;
				for (let i = 1; i <= 12; i++) {
					let obj = {};
					if (m + 1 > 12) {
						m = 0;
						y = y + 1
					}
					m = m + 1
					obj.value = y + '年' + m + '月'
					obj.label = y + '年' + m + '月';
					p.push(obj)
				}
				this.options = this.options.concat(p)
				this.value = this.options[0].value
			},
			//获取签到表详情
			getSignDetail() {
				this.api.planView({}, this.signId).then((res) => {
					this.currentTime = res.data.time_start ? res.data.time_start.substr(0, 5) : '';
					this.currentTimeEnd = res.data.time_end ? res.data.time_end.substr(0, 5) : '';
					let d = JSON.parse(res.data.forenoon); //上午
					let d1 = JSON.parse(res.data.afternoon); //下午
					this.defaultDate = []
					this.defaultDate1 = []
					let y = Number(res.data.month.substr(0, 4));
					let m = Number(res.data.month.substr(4, 2))
					d.map(r => {
						this.defaultDate.push(new Date(y, m - 1, r))
					})
					d1.map(r => {
						this.defaultDate1.push(new Date(y, m - 1, r))
					})
					this.selectTime = this.defaultDate
					this.selectTime1 = this.defaultDate1
					this.value = y + '年' + m + '月';
					this.chooseTime = this.value;
					this.minDate = new Date(y, m - 1, 1);
					this.maxD = new Date(y, m, 0);
					// console.log(this.value)
				})
			},
			del() {
				Dialog.confirm({
						title: '删除',
						message: '确定要删除此签到表？',
					})
					.then(() => {
						this.api.planDelete({}, this.signId).then(res => {
							this.Toast('删除成功')
							setTimeout(() => {
								window.history.go(-1)
							}, 1500)
						})
					})
					.catch(() => {
						// on cancel
					});
			}
		},
		created() {
			this.id = this.$route.query.id;
			if (this.$route.query.signId) {
				this.signId = this.$route.query.signId;
				this.getSignDetail()
			} else {
				this.defaultDate = null
				this.defaultDate1 = null
			}
			this.openType = openType()
			let d = new Date();
			this.chooseTime = d.getFullYear() + '年' + (d.getMonth() + 1) + '月'
			this.maxD = this.getMonthLastDateFn(d.getFullYear(), d.getMonth() + 1);
			this.timeMinDate = new Date(d.getFullYear(), d.getMonth(), 1);
			let nowStr = new Date().getTime() + 1000 * 60 * 60 * 24 * 365
			let mstr = new Date(nowStr);
			let y = mstr.getFullYear();
			let m = mstr.getMonth() + 1;
			let sdstr = new Date(y, m, 0);
			this.timeMaxDate = sdstr;
			// pc端下拉时间选择
			if (this.openType != 'mob') {
				this.pcDateSelectData()
			}
		},
	};
</script>
<style lang="scss" scoped>
	.bottom_btn_1 {
		padding: 0 20px;
		width: 100%;
		box-sizing: border-box;
		// display: flex;
		// justify-content: center;
	}

	.bottom_btn_1 .btn_contenbt {
		margin-top: 20px;
		border-radius: 10px;
		height: 40px;
		background: #00D8CC;
		color: #fff;
		font-size: 18px;
		line-height: 40px;
		text-align: center;
		max-width: 350px;
		width: 100%;
	}

	.calendar-mask {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 999;
	}

	.tab>div.check::after {
		position: absolute;
		width: 20px;
		height: 2px;
		background: #00D8CC;
		content: " ";
		left: 50%;
		transform: translateX(-50%);
		bottom: 0;
	}

	.tab>div {
		padding-bottom: 5px;
	}
</style>
<style type="text/css">
	.van-popup {
		background: transparent !important;
	}

	.van-calendar__month-title {
		display: none;
	}
</style>
